import { SelectOptionItemType } from '@revolut-internal/ui-kit'

import { Queue } from 'modules/Monitoring/types'

export const getGroupedQueues = (
  queues: Queue[],
  specialisationOptions: SelectOptionItemType<string>[],
) => {
  return specialisationOptions.map(specialisationOption => ({
    key: specialisationOption.value,
    label: specialisationOption.label,
    children: queues
      .filter(queue => queue.specialisationId === specialisationOption.value)
      .map(({ id, name }) => ({
        key: id,
        value: id,
        label: name,
      })),
  }))
}
